import { SVGProps } from "react";

const WarningLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={60}
    height={60}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={30} cy={30} r={30} fill="#FFFAEE" />
    <path
      d="M23 26V23.75C23 20.0263 24.1667 17 30 17C35.8333 17 37 20.0263 37 23.75V26"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.5 43H24.5C20.1 43 19 41.5833 19 35.9167V33.0833C19 27.4167 20.1 26 24.5 26H35.5C39.9 26 41 27.4167 41 33.0833V35.9167C41 41.5833 39.9 43 35.5 43Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.9795 35.7998L30.7441 35.2479C30.4821 35.3596 30.3348 35.6402 30.3915 35.9193L30.9795 35.7998ZM29.0195 35.7998L29.6075 35.9192C29.6642 35.6402 29.517 35.3598 29.2551 35.248L29.0195 35.7998ZM30 31V31.6C31.0493 31.6 31.9 32.4507 31.9 33.5H32.5H33.1C33.1 31.7879 31.7121 30.4 30 30.4V31ZM32.5 33.5H31.9C31.9 34.2837 31.4249 34.9576 30.7441 35.2479L30.9795 35.7998L31.2149 36.3517C32.3215 35.8798 33.1 34.7822 33.1 33.5H32.5ZM30.9795 35.7998L30.3915 35.9193C30.3973 35.9476 30.4 35.9744 30.4 36H31H31.6C31.6 35.8884 31.588 35.7814 31.5675 35.6803L30.9795 35.7998ZM31 36H30.4V38H31H31.6V36H31ZM31 38H30.4C30.4 38.2209 30.2209 38.4 30 38.4V39V39.6C30.8837 39.6 31.6 38.8837 31.6 38H31ZM30 39V38.4C29.7791 38.4 29.6 38.2209 29.6 38H29H28.4C28.4 38.8837 29.1163 39.6 30 39.6V39ZM29 38H29.6V36H29H28.4V38H29ZM29 36H29.6C29.6 35.9688 29.6029 35.9419 29.6075 35.9192L29.0195 35.7998L28.4315 35.6804C28.4099 35.787 28.4 35.8942 28.4 36H29ZM29.0195 35.7998L29.2551 35.248C28.5748 34.9576 28.1 34.2836 28.1 33.5H27.5H26.9C26.9 34.7816 27.6778 35.8794 28.784 36.3516L29.0195 35.7998ZM27.5 33.5H28.1C28.1 32.4507 28.9507 31.6 30 31.6V31V30.4C28.2879 30.4 26.9 31.7879 26.9 33.5H27.5Z"
      fill="currentColor"
    />
  </svg>
);
export default WarningLock;
